/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/main.scss";
import { pt } from "vuetify/locale";
import { tokensCor } from "@/design/tokens";
import {
  VNoSsr,
  VSheet,
  VHover,
  VDialog,
  VCard,
  VCardActions,
  VCardItem,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VDivider,
  VBtn,
  VToolbar,
} from "vuetify/components";

// Composables
import { createVuetify } from "vuetify";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: tokensCor.primaria,
          secondary: tokensCor.secundaria,
        },
      },
    },
  },
  locale: {
    locale: "pt",
    messages: { pt },
  },
  components: {
    VNoSsr,
    VSheet,
    VHover,
    VDialog,
    VCard,
    VCardItem,
    VCardTitle,
    VCardSubtitle,
    VCardText,
    VCardActions,
    VDivider,
    VBtn,
    VToolbar,
  },
});
